import type {QueryParams} from '@jetbrains/teamcity-ui/dist/utils'

import type {AppThunk} from '../../../../actions/types'
import type {LoadedEndpoints} from '../../../../routes/loadEndpoint'
import type {BuildId, PipelineId} from '../../../../types'
import {preloadEditPipelinePage} from '../EditPipelinePage/EditPipelinePage.preload'

import {preloadPipelineRunContent} from './PipelineRunContent/PipelineRunContent.preload'

export const preloadPipelineRunPage =
  (pipelineId: PipelineId, runId: BuildId, queryParams: QueryParams): AppThunk<LoadedEndpoints> =>
  dispatch => {
    const {edit} = queryParams
    return edit === 'true'
      ? dispatch(preloadEditPipelinePage(pipelineId, queryParams))
      : dispatch(preloadPipelineRunContent(runId, queryParams))
  }
